import React, { useEffect } from 'react';
import ScrollToTop from './components/ScrollToTop';
import { Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import CookieConsent from './components/CookieConsent';
import AiDrivenSolutionPage from './pages/AiDrivenSolutionPage';
import ServicesDetailsPage from './pages/ServicesDetailsPage';
import ServicesPage from './pages/ServicesPage';
import PricingPage from './pages/PricingPage';
import CaseStudyPage from './pages/CaseStudyPage';
import BlogPage from './pages/BlogPage';
import AboutPage from './pages/AboutPage';
import TeamPage from './pages/TeamPage';
import RequestDemoPage from './pages/RequestDemoPage';
import EduTechPage from './pages/EduTechPage';
import EduTechDetails from './pages/EduTechDetails';
import CompanyPage from './pages/CompanyPage';
import CaseStudyDetails from "./pages/CaseStudyDetails";
import BlogDetailsPage from './pages/BlogDetailsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AiDrivenSolutionDetails from './pages/AiDrivenSolutionDetails';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
import AdminPage from './pages/AdminPage';
import AdminLoginPage from './pages/AdminLoginPage';
import PrivateRoute from './components/PrivateRoute';

import TagManager from 'react-gtm-module';

const gtmId = 'GTM-PM44ZWXV';
TagManager.initialize({ gtmId });

function App() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let title = "TechVelly"; // Default title

    switch (path) {
      case "/":
        title = "TechVelly";
        break;
      case "/ai-solutions":
        title = "AI Solutions - TechVelly";
        break;
      case "/edutech":
        title = "EduTech - TechVelly";
        break;
      case "/services":
        title = "Our Services - TechVelly";
        break;
      case "/pricing":
        title = "Pricing - TechVelly";
        break;
      case "/case-studies":
        title = "Case Studies - TechVelly";
        break;
      case "/blog":
        title = "Blog - TechVelly";
        break;
      case "/about":
        title = "About Us - TechVelly";
        break;
      case "/team":
        title = "Our Team - TechVelly";
        break;
      case "/company":
        title = "Company - TechVelly";
        break;
      case "/request-demo":
        title = "Request a Demo - TechVelly";
        break;
      case "/admin/login":
        title = "Admin Login - TechVelly";
        break;
      default:
        // Handle dynamic routes or unknown paths
        if (path.startsWith("/edutech/")) {
          title = "EduTech Details - TechVelly";
        } else if (path.startsWith("/services/")) {
          title = "Service Details - TechVelly";
        } else if (path.startsWith("/case-studies/")) {
          title = "Case Study Details - TechVelly";
        } else if (path.startsWith("/blog/")) {
          title = "Blog Post - TechVelly";
        }
        break;
    }
    document.title = title;

    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page: {
          path: location.pathname,
          title: title
        }
      }
    });
  }, [location]);

  return (
    <>
    <ScrollToTop />
    <CookieConsent />
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/ai-solutions" element={<AiDrivenSolutionPage />} />
      <Route path="/ai-solutions/:id" element={<AiDrivenSolutionDetails />} />
      <Route path="/edutech" element={<EduTechPage />} />
      <Route path="/edutech/:id" element={<EduTechDetails />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:id" element={<ServicesDetailsPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/case-studies" element={<CaseStudyPage />} />
      <Route path="/case-studies/:id" element={<CaseStudyDetails />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:id" element={<BlogDetailsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/company" element={<CompanyPage />} />
      <Route path="/request-demo" element={<RequestDemoPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
      <Route path="/admin/*" element={<PrivateRoute><AdminPage /></PrivateRoute>} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
    </Routes>
    </>
  );
}

export default App;